<script lang="ts">
  import { isMobileWidth } from '../../../../common/util';
  import PictureTag from '../PictureTag.svelte';

  export let content = {
    title: '',
    subTitle: '',
    icon: '',
    mobileIcon: '',
  };
  const isResponsive = isMobileWidth();
  // Boolean to determine the image position
  export let reverseLayout = false;
</script>

<div class="row-flex" class:reverse={reverseLayout}>
  <div class="text-section col-flex-md-6 col-flex-xs-7">
    <h5>{content.title}</h5>
    <p>{content.subTitle}</p>
  </div>
  <div class="image-section col-flex-md-5 col-flex-xs-4">
    <PictureTag
      image={content?.icon}
      mobileImage={content?.mobileIcon}
      alt={content?.title}
      height={isResponsive ? '70' : '250'}
    />
  </div>
</div>

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .row-flex {
    align-items: center;
    justify-content: space-between;
    @include desktop-max-width {
      margin: 0;
    }
    .text-section {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 0;
      justify-content: center;
      align-self: stretch;
      // max-width: 47.6%;
      @include desktop-max-width {
        padding: 0;
      }

      h5 {
        font-weight: 700;
        font-size: 26px;
        line-height: 40px;
        margin: 0;
        @include desktop-max-width {
          font-size: 14px;
        }
      }
      p {
        color: $neutral-dark-02;
        font-weight: 400;
        font-size: 16px;
        margin: 0;
        line-height: 20px;
        @include desktop-max-width {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
    .image-section {
      background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
      align-self: stretch;
      justify-content: center;
      display: flex;
      align-items: center;
      padding: 0;
      min-height: 311px;
      border-radius: 24px;
      // min-width: 44.9%;
      @include desktop-max-width {
        border-radius: 8px;
        min-height: 130px;
      }
    }
  }

  /* Alternate image placement */
  .container.reverse {
    flex-direction: row-reverse; /* Swap the order of content */
  }
</style>
